import React from 'react';
import { Outlet } from 'react-router-dom';

const TeamPage = () => {

    return <Outlet/>

}


export default TeamPage